module.exports = __webpack_public_path__ + "static/img/exposure-pc-2.236db5bb.png";